import React, { Component } from 'react'

// Elements
import SideMenuCustomItem from '../sideMenuCustomItem'
import Text from '../text'
import Check from '../check'
import ArrowButton from '../arrowButton'

// Styles
import './sideMenu.scss'

// Utils
import { translation } from '../../../utils/helpers'

class SideMenu extends Component {
  constructor (props) {
    super(props)

    this.state = {
      collapsed: false,
      filter: '',
      showInactive: props.defaultShowInactive
    }

    this.onChange = this.onChange.bind(this)
  }

  onChange (e) {
    let { name, value, checked } = e.target

    if (name === 'showInactive') {
      value = checked
    }

    this.setState({
      [name]: value
    })
  }

  filterItems () {
    const { showFilter, hideInactiveCheck, disableFilter } = this.props
    if ((!showFilter && hideInactiveCheck) || disableFilter) {
      return this.props.children
    }

    const { filter, showInactive } = this.state
    const children = React.Children.toArray(this.props.children)

    // Filter method
    const filterChildren = (filteredChildren, child, key) => {
      const { label, isTitle, isFixed, className } = child.props
      if (label === undefined && !isFixed && className !== 'filter') return filteredChildren

      // Filter on childs children
      if (child.props.children) {
        const newProps = {
          ...child.props,
          key,
          children: isFixed ? React.Children.toArray(child.props.children) : React.Children.toArray(child.props.children).reduce(filterChildren, [])
        }

        const withFilteredChildren = React.cloneElement(child, newProps)
        return [ ...filteredChildren, withFilteredChildren ]
      }

      // Filter on label
      const matchesFilter = !filter || label.toLowerCase().includes(filter.toLowerCase())

      // Filter on activity
      if (isTitle || isFixed) {
        return [ ...filteredChildren, child ]
      }

      if (matchesFilter) {
        if (this.props.customFilter(child.props, showInactive)) {
          return [ ...filteredChildren, child ]
        }
      }

      return filteredChildren
    }

    return children.reduce(filterChildren, [])
  }

  renderCollapseButton () {
    return (
      <div className='collapse-btn'>
        <ArrowButton size='m' dir={this.state.collapsed ? 'right' : 'down'} onClick={() => { this.setState({collapsed: !this.state.collapsed}) }} />
      </div>
    )
  }

  render () {
    const { showFilter, hideInactiveCheck, disableFilter } = this.props

    let shouldRenderFilter = true
    if ((!showFilter && hideInactiveCheck) || disableFilter) {
      shouldRenderFilter = false
    }

    const onItemClick = (e) => {
      // Collapse menu when a side menu item is clicked
      if (typeof e.target.classList.contains === 'function' && e.target.classList.contains('element-sidemenu-item__label')) {
        // console.log('Clicked an item!')
        if (!this.state.collapsed) {
          this.setState({collapsed: true})
        }
      }
    }

    let additionalCss = ''
    if (this.state.collapsed) additionalCss = ' collapsed'
    return (
      <div className={'element-sidemenu' + additionalCss} onClick={onItemClick}>
        {this.renderCollapseButton()}
        {shouldRenderFilter && (
          <div className='filterOptions'>
            {showFilter && (
              <SideMenuCustomItem>
                <Text
                  name='filter'
                  value={this.state.filter}
                  onChange={this.onChange}
                />
              </SideMenuCustomItem>
            )}

            {!hideInactiveCheck && (
              <SideMenuCustomItem>
                <Check
                  name='showInactive'
                  checked={this.state.showInactive}
                  onChange={this.onChange}
                  labelText={translation('1859')}
                  spacing={0}
                />
              </SideMenuCustomItem>
            )}
          </div>
        )}

        {this.filterItems()}
      </div>
    )
  }
}

SideMenu.defaultProps = {
  showFilter: true,
  // hideFilter: false,
  hideInactiveCheck: false,
  disableFilter: false,
  defaultShowInactive: false,
  customFilter: (props, showInactive) => {
    return showInactive || !props.inactive
  }
}

export default SideMenu



// WEBPACK FOOTER //
// ./src/app/shared/elements/sideMenu/index.js